import React, { useState, useEffect } from 'react';
import ContactServices from '../services/ContactServices';
import useAsync from '../hooks/useAsync';

function NumberBooking() {
  const { data, error, isLoading } = useAsync(ContactServices.getNumberOfBooking);

  const [formValues, setFormValues] = useState({
    numberOfBooking: '',
  });

  useEffect(() => {
    if (data?.data) {
      setFormValues({
        numberOfBooking: data.data.numberOfBooking || '',
     
      });
    }
  }, [data]);

  

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await ContactServices.updateNumberOfBooking(data.data._id, formValues);
      alert('Number Of Booking details updated successfully');
    } catch (error) {
      console.error('Failed to update Number Of Booking details', error);
      alert('Failed to update Number Of Booking details');
    }
  };

  if (isLoading) {
    return <div className="loader design_loading">Loading...</div>;
  }

  if (error) {
    return <div>Error loading Refer & Earn details</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Number Of Booking</h2>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner table-reponsive-tabe">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Number Of Booking</label>
                    <input
                      type="number"
                      name="numberOfBooking"
                      className="form-control"
                      value={formValues.numberOfBooking}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NumberBooking;
